<template>
    <div id="wsd" class = 'container fluid'>
        <survey-container
            :currentQ="currentQ"
            :questionData="questionData"
        ></survey-container>
    </div>
</template>

<script>
import store from '../store.js'
import SurveyContainer from './survey-components/SurveyContainer.vue'
export default {
    components: {SurveyContainer},
    data(){
        return {
            currentQ: store.state.currentQ,
            questionData: store.state.questionData,
        }
    },
    setup(){
        store.updateCurrentQ(1)
    }
    
}

</script>
       